import { render } from "./BaseButtonClose.vue?vue&type=template&id=13664500&ts=true"
import script from "./BaseButtonClose.vue?vue&type=script&lang=ts"
export * from "./BaseButtonClose.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/agnisvegners/Projects/anatomynext/hpc-new/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__